
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The inaugural release of PX Blue 2.0 is the first release of our newly updated Design System. We now support a wide range of platforms and technologies with comprehensive documentation for using the design system.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;